import { render, staticRenderFns } from "./addRemark.vue?vue&type=template&id=f1255db0&scoped=true&"
import script from "./addRemark.vue?vue&type=script&lang=js&"
export * from "./addRemark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1255db0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1255db0')) {
      api.createRecord('f1255db0', component.options)
    } else {
      api.reload('f1255db0', component.options)
    }
    module.hot.accept("./addRemark.vue?vue&type=template&id=f1255db0&scoped=true&", function () {
      api.rerender('f1255db0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/overdue/addRemark.vue"
export default component.exports